export const state = {
  trips: [],
  systemTrip: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/trips/state.js